// Module
var code = "<mx-object-picker label=\"{{::vm.i18n.chooseValue}}\" flex ng-model=\"vm.condition.value\" ng-required=\"true\" entity-class-name=\"{{::vm.condition._options.ReferenceTo}}\" data-selected-item=\"vm.selectedItem\">\r\n</mx-object-picker>\r\n<br>";
// Exports
export default code;